import { Star, BookOpen, BarChart, Clock } from 'lucide-react';

function CourseDetails({close,setRefresh,lesson}) {

    return (
        <div className=" py-4 px-2 sm:px-1 lg:px-2">
            <div className="mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
                {/* Course Image */}
                <div className="relative h-72 w-full">
                    <img
                        src={lesson?.lessonImage}
                        alt={lesson?._id}
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                        {lesson?.status}
                    </div>
                </div>

                {/* Course Content */}
                <div className="p-8">
                    {/* Header Section */}
                    <div className="mb-6">
                        <div className="flex items-center justify-between mb-2">
                            <h1 className="text-3xl font-bold text-gray-900">{lesson?.title}</h1>
                            <div className="flex items-center gap-1">
                                {/* <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" /> */}
                                <span className="text-lg font-semibold">{lesson?.access_type}</span>
                            </div>
                        </div>
                        <div className="flex flex-col gap-4 text-sm text-gray-600">
                            <span>Lesson ID: <span className='font-semibold'>{lesson?.courseId}</span></span>
                            <span>Internal ID: <span className='font-semibold'>{lesson?._id}</span></span>
                            <span>Course ID: <span className='font-semibold'>{lesson?.courseId}</span></span>
                            <span>Chapter ID: <span className='font-semibold'>{lesson?.chapterId}</span></span>
                            <span className='break-words'>File: <span className='font-semibold'>{lesson?.file}</span></span>
                            <span>File type: <span className='font-semibold'>{lesson?.fileType}</span></span>
                        </div>
                    </div>

                    {/* Stats Grid */}
                    {/* <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mb-8">
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center gap-2 text-gray-600 mb-1">
                                <BookOpen className="w-4 h-4" />
                                <span>Lessons</span>
                            </div>
                            <p className="text-xl font-bold">{course?.total_lesson}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center gap-2 text-gray-600 mb-1">
                                <BarChart className="w-4 h-4" />
                                <span>Chapters</span>
                            </div>
                            <p className="text-xl font-bold">{course?.total_chapters}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center gap-2 text-gray-600 mb-1">
                                <Clock className="w-4 h-4" />
                                <span>Priority</span>
                            </div>
                            <p className="text-xl font-bold">{course?.course_precedance}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex flex-col">
                                <span className="text-gray-600">Price</span>
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="text-xl font-bold">${discountedPrice.toFixed(2)}</span>
                                    <div>
                                        <span className="text-sm text-gray-500 line-through mr-2">${course?.course_price}</span>
                                        <span className="text-green-500 text-sm">-{course?.course_discount_percentage}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* Description */}
                    <div className="mb-8">
                        <h2 className="text-xl font-semibold mb-4">Lesson Description</h2>
                        <p className="text-gray-600 leading-relaxed">
                            {lesson?.description}
                        </p>
                    </div>

                    {/* CTA Button */}
                    {/* <button className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                        Enroll Now
                    </button> */}
                </div>
            </div>
        </div>
    );
}

export default CourseDetails;